import { createContext } from "react"

export interface FinancePerformanceContextType {
	selectedDateRangeStart: Date
	setSelectedDateRangeStart: (selectedDateRangeStart: Date) => void
	selectedDateRangeEnd: Date
	setSelectedDateRangeEnd: (selectedDateRangeEnd: Date) => void
	graphInterval?: "day" | "month"
	setGraphInterval?: (graphInterval: "day" | "month") => void
}

export const FinancePerformanceContext =
	createContext<FinancePerformanceContextType>(null!)
